import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';

export const deleteContactUsMessageRequest = createAction('deleteContactUsMessageRequest');
export const deleteContactUsMessageSuccess = createAction('deleteContactUsMessageSuccess');
export const deleteContactUsMessageFailure = createAction('deleteContactUsMessageFailure');

export const deleteContactUsMessage = (id: number) => async (
    dispatch: AppDispatch,
): Promise<void> => {
    dispatch(deleteContactUsMessageRequest());

    try {
        await api.delete(`admin/contactusmessages/${id}`);

        dispatch(deleteContactUsMessageSuccess());
    } catch (e) {
        handleApiErrors(dispatch, deleteContactUsMessageFailure, e);
    }
};
